import { render, staticRenderFns } from "./quizzParent.vue?vue&type=template&id=c1a8519c&"
import script from "./quizzParent.vue?vue&type=script&lang=js&"
export * from "./quizzParent.vue?vue&type=script&lang=js&"
import style0 from "./quizzParent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports